<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="tipDialog"
      top="10vh"
      width="500px"
    >
      <!-- 1. 确认提示区域（点击确定前显示） -->
      <div v-if="isShowConfirm" style="font-size: 16px">
        <div style="margin-bottom: 15px">
          <span>{{ $t('GlobalSetObj.Selecionadas') }}: </span>
          <span style="color: #00A551"> {{ selectedData.length }}</span>
        </div>
        <div style="margin-bottom: 15px; font-weight: bold">
          {{ $t('vehicle.confirmBatchFinalApproval') }}
        </div>
      </div>

      <!-- 2. 结果展示区域（接口完成后显示） -->
      <div v-if="isShowResult" style="font-size: 14px">
        <div class="flx-between" style="margin-bottom: 15px">
          <div>
            {{ $t('operationCenter.TotalQuantity') }}：<span style="color: #00A551">{{
              auditResult.totalCount
            }}</span>
          </div>
          <div>
            {{ $t('operationCenter.TheOperationSucceeded') }}：{{ auditResult.successCount }}
          </div>
          <div>
            {{ $t('mdfeTranslate.OperationFailed') }}：<span style="color: red">{{
              auditResult.failCount
            }}</span>
          </div>
        </div>
        <div v-if="auditResult.failCount > 0" style="color: red">
          {{ $t('GlobalSetObj.ReasonForFailure') }} :
        </div>
        <div style="margin-bottom: 15px; line-height: 25px; color: #00A551; letter-spacing: 1px">
          <div v-for="(reason, index) in auditResult.failReasonList" :key="index">
            {{ reason }}
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- 结果页面：只显示【关闭】按钮 -->
        <el-button
          v-if="isShowResult" size="small" type="primary"
          @click="confirmFinalAudit(1)"
        >
          {{ $t('GlobalSetObj.close') }}
        </el-button>

        <!-- 确认页面：显示【取消 + 确定】 -->
        <template v-else>
          <el-button size="small" @click="confirmFinalAudit(1)">
            {{ $t('GlobalSetObj.cancel') }}
          </el-button>
          <el-button size="small" type="primary" @click="confirmFinalAudit(2)">
            {{ $t('GlobalSetObj.confirm') }}
          </el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { lmPenaltyBillAudit } from '@/api/definiteResponsibilityAndPenalty';

export default {
  data() {
    return {
      tipDialog: false,
      selectedData: [],
      isShowConfirm: true, // 显示确认提示
      isShowResult: false, // 显示结果
      auditResult: {
        totalCount: 0,
        successCount: 0,
        failCount: 0,
        failReasonList: []
      }
    };
  },
  methods: {
    confirmFinalAudit(val) {
      // 取消
      if (val === 1) {
        this.tipDialog = false;
        this.resetDialog(); // 重置状态
        return;
      }

      // 确定 → 调用审核接口
      const data = {
        idList: this.selectedData.map((item) => item.id)
      };
      lmPenaltyBillAudit(data).then((res) => {
        if (res.code === 200) {
          // 赋值结果
          this.auditResult = res.data;
          // 切换显示：隐藏确认 → 显示结果
          this.isShowConfirm = false;
          this.isShowResult = true;
          this.$emit('call-parent-search');
        }
      });
    },

    // 打开弹窗时重置状态
    showTIP(arg) {
      this.resetDialog();
      this.selectedData = arg;
      this.tipDialog = true;
    },

    // 重置弹窗状态
    resetDialog() {
      this.isShowConfirm = true;
      this.isShowResult = false;
      this.auditResult = {
        totalCount: 0,
        successCount: 0,
        failCount: 0,
        failReasonList: []
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.dispatchName {
  width: 100%;
  height: 39px;
  border: 1px solid #dbdee5;
  padding-left: 10px;
  text-align: left;
  border-radius: 4px;
}
</style>
